export default {
  // 首页
  home: {
    mainTabs: [
      { name: "院内新闻", value: "institute", categoryId: 10201 },
      { name: "交大新闻", value: "university", categoryId: 10202 },
      { name: "媒体聚焦", value: "media", categoryId: 10203 },
    ],
  },

  // 关于研究院
  about: {
    mainTabs: [
      { name: "研究院简介", value: "intro", categoryId: 201 },
      { name: "历史沿革", value: "history", categoryId: 202 },
      { name: "组织架构", value: "organization", categoryId: 203 },
      { name: "荣誉资质", value: "honors", categoryId: 204 },
    ],
    subTabs: {
      history: [
        { title: "发展历程", categoryId: 20201 },
        { title: "大事记", categoryId: 20202 },
      ],
    },
  },

  // 科学研究
  research: {
    mainTabs: [
      /*
      {
        name: "科研方向",
        value: "direction",
        categoryId: 301,
      },
      */
      {
        name: "科研成果",
        value: "achievement",
        categoryId: 302,
      },
      { name: "科研平台", value: "platform", categoryId: 303 },
      {
        name: "协同平台",
        value: "collaboration",
        categoryId: 304,
      },
      {
        name: "国际合作",
        value: "international",
        categoryId: 305,
      },
    ],
    subTabs: {
      achievement: [
        { title: "应用研究", categoryId: 30201 },
        { title: "中试产业化", categoryId: 30202 },
      ],
      platform: [
        { title: "乳业制造业集群", categoryId: 30301 },
        { title: "国家工程中心内蒙分中心", categoryId: 30302 },
        { title: "省部级实验室", categoryId: 30303 },
        { title: "院内实验室", categoryId: 30304 },
      ],
      collaboration: [
        { title: "校地平台", categoryId: 30401 },
        { title: "校企合作", categoryId: 30402 },
        { title: "伙伴计划", categoryId: 30403 },
      ],
    },
  },

  // 数字平台
  digital: {
    mainTabs: [
      //{ name: "科研管理平台", value: "platform", url: "https://rgznjmcx.sjtu.edu.cn/login?redirect=%2Findex" },
      { name: "科研管理平台", value: "platform", url: "http://36.134.92.27:8091/#/login" },
      { name: "检测平台", value: "detection", url: "http://keyi.gongyun2025.com" },
      //{ name: "工业互联网平台", value: "internet", url: "https://gongye.sjtu.edu.cn/login?redirect=%2Findex" },
      // { name: "工业互联网平台", value: "internet", url: "http://keyi.gongyun2025.com/#/" },
      { name: "材料智能热制造创新平台", value: "material", url: "https://rgznjmcx.sjtu.edu.cn/login?redirect=%2Findex" },
    ],
  },

  // 人才培养
  education: {
    mainTabs: [
      { name: "学历教育", value: "academic", categoryId: 401 },
      { name: "非学历教育", value: "non-academic", categoryId: 402 },
      { name: "科普实践", value: "science", categoryId: 403 },
    ],
    subTabs: {
      academic: [
        { title: "学历教育概况", categoryId: 40101 },
        { title: "师资队伍", categoryId: 40102 },
        { title: "联培企业", categoryId: 40103 },
        { title: "学生风采", categoryId: 40104 },
        { title: "社会实践", categoryId: 40105 },
        { title: "招生简章", categoryId: 40106 },
      ],
      nonAcademic: [
        { title: "非学历教育概况", categoryId: 40201 },
        { title: "定制课（研学）", categoryId: 40202 },
        { title: "公开课", categoryId: 40203 },
      ],
      science: [
        { title: "科普基地", categoryId: 40301 },
        { title: "科普活动", categoryId: 40302 },
      ],
    },
  },

  // 创新基地
  innovation: {
    mainTabs: [
      { name: "创新基地概况", value: "overview", categoryId: 501 },
      { name: "呼和浩特科创中心", value: "hohhot", categoryId: 502 },
      { name: "包头中试基地", value: "baotou-pilot", categoryId: 503 },
      { name: "上海科创飞地", value: "shanghai", categoryId: 504 },
      {
        name: "包头氢能装备制造基地",
        value: "baotou-hydrogen",
        categoryId: 505,
      },
    ],
  },

  // 党群文化
  party: {
    mainTabs: [
      { name: "党建概况", value: "overview", categoryId: 601 },
      { name: "专题学习", value: "special", categoryId: 602 },
      { name: "理论学习", value: "theory", categoryId: 603 },
      { name: "工会妇联", value: "union", categoryId: 604 },
      { name: "党日活动", value: "activity", categoryId: 605 },
      { name: "青联", value: "youth", categoryId: 606 },
    ],
    subTabs: {
      overview: [
        { title: "内蒙院党支部", categoryId: 60101 },
        { title: "包头院党支部", categoryId: 60102 },
        { title: "党建联盟", categoryId: 60103 },
      ],
      union: [
        { title: "工会概况", categoryId: 60401 },
        { title: "妇联概况", categoryId: 60402 },
        { title: "工会", categoryId: 60403 },
        { title: "妇联", categoryId: 60404 },
      ],
    },
  },

  // 人力资源
  hr: {
    mainTabs: [
      { name: "人才团队", value: "team", categoryId: 701 },
      { name: "人才招聘", value: "recruitment", categoryId: 702 },
    ],
  },

  // 新闻动态
  news: {
    mainTabs: [
      { label: "院内新闻", value: "institute", categoryId: 10201 },
      { label: "交大新闻", value: "university", categoryId: 10202 },
      { label: "媒体聚焦", value: "media", categoryId: 10203 },
    ],
  },

  // 活动预告
  event: {
    mainTabs: [
      { label: "院内新闻", value: "institute", categoryId: 102 },
      { label: "交大新闻", value: "university", categoryId: 102 },
      { label: "媒体聚焦", value: "media", categoryId: 102 },
    ],
  },
};
